import { render, staticRenderFns } from "./AwardsVideoLink.vue?vue&type=template&id=12f6e973&scoped=true"
import script from "./AwardsVideoLink.vue?vue&type=script&lang=js"
export * from "./AwardsVideoLink.vue?vue&type=script&lang=js"
import style0 from "./AwardsVideoLink.vue?vue&type=style&index=0&id=12f6e973&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6e973",
  null
  
)

/* custom blocks */
import block0 from "./AwardsVideoLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports